// ABOUTME: Sidebar collapse preference storage with two-tier semantics
// ABOUTME: session key tracks current state; default key seeds initial state on first load

export const SIDEBAR_SESSION_KEY = 'sidebar-collapsed';
export const SIDEBAR_DEFAULT_KEY = 'sidebar-default-collapsed';

function safeRead(key: string): boolean | null {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    const parsed = JSON.parse(raw) as unknown;
    return typeof parsed === 'boolean' ? parsed : null;
  } catch {
    return null;
  }
}

function safeWrite(key: string, value: boolean) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // localStorage may be unavailable (private mode, quota) — silently skip
  }
}

export function getInitialSidebarCollapsed(): boolean {
  const session = safeRead(SIDEBAR_SESSION_KEY);
  if (session !== null) return session;
  const fallback = safeRead(SIDEBAR_DEFAULT_KEY);
  return fallback ?? false;
}

export function setSidebarCollapsed(value: boolean) {
  safeWrite(SIDEBAR_SESSION_KEY, value);
}

export function getSidebarDefault(): boolean {
  return safeRead(SIDEBAR_DEFAULT_KEY) ?? false;
}

export function setSidebarDefault(value: boolean) {
  safeWrite(SIDEBAR_DEFAULT_KEY, value);
}
